/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Features_Watch_OfInputs */

const en_features_watch_of = /** @type {(inputs: Features_Watch_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`of ${i?.total}`)
};

const pl_features_watch_of = /** @type {(inputs: Features_Watch_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`z ${i?.total}`)
};

/**
* | output |
* | --- |
* | "of {total}" |
*
* @param {Features_Watch_OfInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_watch_of = /** @type {((inputs: Features_Watch_OfInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Watch_OfInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_watch_of(inputs)
	return en_features_watch_of(inputs)
});